import qs from "qs";
import apiClient from './apiClient';
import {UserCar} from "../types/UserCar";

const fetchUserCarList = async (userId: string): Promise<UserCar[]> => {
	const response = await apiClient.get(`/api/admin/business/user/car/${userId}`);
	return response.data;
}

const userCarAPI = {
	fetchUserCarList,
}

export default userCarAPI;

